import { Modal, Typography } from "@material-ui/core";
import React from "react";
import { getTerminalId } from "../../../services";
import { PaymentMethod } from "../../../types";
import { Button } from "../../index";
import useStyles from "./styles";

export interface StudentPaymentMethodModalProps {
  open: boolean;
  onClose: () => void;
  onSelectBalance: () => void;
  onSelectPaymentMethod: (method: PaymentMethod) => void;
  balanceSufficient?: boolean;
  isPixEnabled?: boolean;
}

export const StudentPaymentMethodModal: React.FC<
  StudentPaymentMethodModalProps
> = ({
  open,
  onClose,
  onSelectBalance,
  onSelectPaymentMethod,
  balanceSufficient = true,
  isPixEnabled = true,
}) => {
  const Styles = useStyles();

  return (
    <Modal className={Styles.modal} open={open} onClose={onClose}>
      <div className={Styles.modalView}>
        <Typography component="span" className={Styles.title}>
          Como deseja pagar?
        </Typography>
        <Typography component="span" className={Styles.message}>
          Escolha o método de pagamento
        </Typography>
        <div className={Styles.actions}>
          <Button
            onClick={onSelectBalance}
            disabled={!balanceSufficient}
            style={!balanceSufficient ? { opacity: 0.4 } : undefined}
          >
            Saldo do Cartão
          </Button>
          {isPixEnabled && (
            <Button onClick={() => onSelectPaymentMethod(PaymentMethod.PIX)}>
              Pix
            </Button>
          )}
          {getTerminalId() && (
            <>
              <Button
                onClick={() =>
                  onSelectPaymentMethod(PaymentMethod.DEBIT_CARD)}
              >
                Cartão de Débito
              </Button>
              <Button
                onClick={() =>
                  onSelectPaymentMethod(PaymentMethod.CREDIT_CARD)}
              >
                Cartão de Crédito
              </Button>
            </>
          )}
        </div>
      </div>
    </Modal>
  );
};
